import Cookies from "js-cookie";
import axios from "axios";
import { BACKEND_API_URL } from "../utils/api";

const getAuthHeaders = () => ({
    Authorization: `Token ${Cookies.get("access_token")}`,
    "Content-Type": "application/json",
});

const getMultipartHeaders = () => ({
    Authorization: `Token ${Cookies.get("access_token")}`,
    "Content-Type": "multipart/form-data",
});

/**
 * Fetch recent tags for the current user
 */
export const fetchRecentTags = async () => {
    const response = await axios.get(
        `${BACKEND_API_URL}/api/recent_tags`,
        { headers: getAuthHeaders() }
    );
    return response.data.recent_tags || [];
};

/**
 * Rename a folder or link
 */
export const renameItem = async (id, name) => {
    const response = await axios.post(
        `${BACKEND_API_URL}/api/folder/rename/${id}`,
        { name },
        { headers: getAuthHeaders() }
    );
    return response.data;
};

/**
 * Update link URL
 */
export const updateLinkUrl = async (id, link) => {
    const response = await axios.post(
        `${BACKEND_API_URL}/api/link/update/${id}`,
        { link },
        { headers: getAuthHeaders() }
    );
    return response.data;
};

/**
 * Change archive status for an item
 */
export const changeArchiveStatus = async (id, status) => {
    const response = await axios.get(
        `${BACKEND_API_URL}/api/item_archive_status_change/${id}?status=${status}`,
        { headers: getAuthHeaders() }
    );
    return response.data;
};

/**
 * Toggle bookmark status for an item
 */
export const toggleBookmark = async (id) => {
    const response = await axios.post(
        `${BACKEND_API_URL}/api/item/bookmark/toggle/${id}`,
        {},
        { headers: getAuthHeaders() }
    );
    return response.data;
};

/**
 * Change folder status
 */
export const changeFolderStatus = async (id, status) => {
    const response = await axios.get(
        `${BACKEND_API_URL}/api/folder_status_change/${id}?status=${status}`,
        { headers: getAuthHeaders() }
    );
    return response.data;
};

/**
 * Delete an item (folder or link)
 */
export const deleteItem = async (id, itemType) => {
    const response = await axios.post(
        `${BACKEND_API_URL}/api/${itemType}/delete/${id}`,
        {},
        { headers: getAuthHeaders() }
    );
    return response.data;
};

/**
 * Add a comment to an item
 */
export const addComment = async (id, comment, mediaType, mediaFile) => {
    const formData = new FormData();
    formData.append("comment", comment);
    formData.append("media_type", mediaType);
    formData.append("media_file", mediaFile);

    const response = await axios.post(
        `${BACKEND_API_URL}/api/item/comment/add/${id}`,
        formData,
        { headers: getMultipartHeaders() }
    );
    return response.data;
};

/**
 * Create description Google Doc for a folder
 */
export const createDescriptionGoogleDoc = async (id) => {
    const response = await axios.post(
        `${BACKEND_API_URL}/api/folder/create_description_gdoc/${id}`,
        {},
        { headers: getAuthHeaders() }
    );
    return response.data;
};
